<xemex-page-header
  [title]="installation()?.name ?? ''"
  [subtitle]="address()"
  [breadcrumbs]="breadcrumbs()"
  [badges]="badges()"
  [badgePlacement]="'subtitle'"
  [loading]="headerLoading()"
  [withBackground]="true"
  [withTabBar]="true"
  [icon]="'electric_bolt'"
  [iconOutlined]="true"
>
  <xemex-tab-bar [tabs]="tabs()" [defaultTab]="0" (tabChange)="onTabChange($event)"></xemex-tab-bar>
</xemex-page-header>

<xemex-page-body [scrollable]="true">
  @if (installation(); as detail) {
    @switch (shownTab()) {
      @case ('general') {
        <xemex-installation-general-tab [installation]="detail" />
      }
      @case ('insights') {
        <xemex-installation-insights-tab [installation]="detail" />
      }
      @case ('data-sources') {
        <xemex-installation-data-sources-tab [installation]="detail" />
      }
      @case ('alarms') {
        <xemex-installation-alarms-tab
          [installationOid]="detail.installationOid"
          [devices]="feedingDevices()"
        />
      }
      @case ('activity') {
        <xemex-installation-activity-tab
          [installationOid]="detail.installationOid"
          [devices]="feedingDevices()"
        />
      }
      @case ('settings') {
        <xemex-installation-settings-tab [installation]="detail" />
      }
    }
  } @else if (installationStore.detailError()) {
    <p class="text-text-secondary">{{ 'installations.detail.notFound' | translate }}</p>
  }
</xemex-page-body>
